import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import moment from 'moment'
import { VoucherType } from '@/types'
import Axios from 'axios'

@Component
export default class DocumentFilterComponent extends Vue {
  from: string = new Date().toISOString().substr(0, 10)
  to: string = new Date().toISOString().substr(0, 10)
  fromModal: boolean = false
  toModal: boolean = false
  voucherTypes: VoucherType[] = []
  series: string[] = []
  seriesSelected: string[] = []
  customers: string[] = []
  customersSelected: string[] = []
  voucherTypesSeleted: VoucherType[] = []
  correlative: string = ''

  mounted () {
    this.onLoadVoucherTypes()
    this.onLoadSeries()
    this.onLoadCustomers()
  }

  onLoadVoucherTypes () {
    Axios.get('/documents/voucher-type').then(response => {
      this.voucherTypes = response.data
    })
  }

  onLoadSeries () {
    Axios.get('/documents/series').then(response => {
      this.series = response.data.map((item:any) => item.nser)
    })
  }

  onLoadCustomers () {
    Axios.get('/documents/customers').then(response => {
      this.customers = response.data.map((item:any) => item.nomb_clie)
    })
  }

  get fromComputed () {
    return moment(this.from).format('DD/MM/YYYY')
  }

  get toComputed () {
    return moment(this.to).format('DD/MM/YYYY')
  }

  @Prop(Boolean)
  open!: boolean

  @Emit()
  toggle (event:boolean) {
  }

  @Emit()
  filter () {
    return {
      from: this.from,
      to: this.to,
      voucherTypes: this.voucherTypesSeleted,
      serieNumbers: this.seriesSelected,
      customerNames: this.customersSelected,
      correlative: this.correlative
    }
  }
}
